module.exports = __webpack_public_path__ + "img/l6.3d052efe.png";